import './set-public-path';
import React from 'react';
import ReactDOM from 'react-dom';
import RootComponent from './root.component.js';
import singleSpaReact from 'single-spa-react';
import singleSpaCanopy from 'single-spa-canopy';
import primaryNavBarStyles from './practitioner/primary-navbar.styles.css';
import clientPortalNavBarStyles from './client-portal/client-portal.styles.css';
import _NavContent from './nav-content.component.js';
import _TopnavSecondary from './topnav-secondary.component.js';
import _Dialog from './dialog.component.js';
import { recalculatePrimaryNavHeight } from './primary-nav-height.helpers.js';
import { recalculatePrimaryNavWidth } from './primary-nav-width.helpers.js';
import { first } from 'rxjs/operators';
import { hasAccess } from 'cp-client-auth!sofe';

const toggles = ['toggle_transcripts_module', 'crm_display_name', 'ft_react_letters'];

export function fetchToggles() {
  if (toggles.length) {
    return SystemJS.import('feature-toggles!sofe').then(ft => {
      return ft.fetchFeatureToggles(...toggles);
    });
  } else return Promise.resolve();
}

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: RootComponent,
  domElementGetter,
});

const canopyLifecycles = singleSpaCanopy({
  mainContentTransition: false,
  domElementGetter,
  featureToggles: toggles,
  hotload: {
    module,
    __webpack_require__,
    dev: {
      enabled: true,
    },
  },
  overlay: {
    selectors: [`.${primaryNavBarStyles.navbar}`, `.${clientPortalNavBarStyles.navbar}`],
  },
});

export const NavContent = _NavContent;
export const TopnavSecondary = _TopnavSecondary;
export const Dialog = _Dialog;
export { primaryNavHeightObs, usePrimaryNavHeight } from './primary-nav-height.helpers.js';
export { primaryNavWidthObs, usePrimaryNavWidth } from './primary-nav-width.helpers.js';

export const bootstrap = [
  fetchToggles,
  // initialize navbar height ASAP
  () => {
    return SystemJS.import('cp-client-auth!sofe').then(authModule => {
      const userPromise = authModule.default.getLoggedInUserAsObservable().pipe(first()).toPromise();

      const tenantPromise = authModule.default.getTenantAsObservable().pipe(first()).toPromise();

      return Promise.all([userPromise, tenantPromise]).then(([user, tenant]) => {
        recalculatePrimaryNavHeight(user, tenant);
        recalculatePrimaryNavWidth();
        return Promise.resolve();
      });
    });
  },
  canopyLifecycles.bootstrap,
  reactLifecycles.bootstrap,
];

export const mount = [reactLifecycles.mount, canopyLifecycles.mount];

export const unmount = [canopyLifecycles.unmount, reactLifecycles.unmount];

export const unload = [canopyLifecycles.unload];

export function checkPermissions(user, type) {
  // will be addressing permissions Fall 2020 and hopefully making this much better
  if (type === 'transcripts-only') return hasAccess(user)(['transcripts']) && !hasAccess(user)(['contacts']);
  else if (type === 'notices-only') {
    return hasAccess(user)(['tasks_notices']) && !hasAccess(user)(['forms', 'transcripts']);
  } else {
    throw new Error(`Second parameter to "checkPermissions()" ${type} was not provided or is invalid`);
  }
}

function domElementGetter() {
  let el = document.getElementById('primary-navbar');
  if (!el) {
    el = document.createElement('div');
    el.id = 'primary-navbar';
    document.body.appendChild(el);
  }

  return el;
}
